var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentPersonal = function SvgDocumentPersonal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#DocumentPersonal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.686 40.029a3 3 0 0 1 3-3h63.943a3 3 0 0 1 3 3V79.97a3 3 0 0 1-3 3H27.686a3 3 0 0 1-3-3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M23.914 31.457a4.8 4.8 0 0 0-4.8 4.8v6.195a.6.6 0 0 1-1.2 0v-6.195a6 6 0 0 1 6-6h7.136a.6.6 0 0 1 0 1.2zm63.107-.6a.6.6 0 0 1 .6-.6H95.4a6 6 0 0 1 6 6v6.195a.6.6 0 0 1-1.2 0v-6.195a4.8 4.8 0 0 0-4.8-4.8H87.62a.6.6 0 0 1-.6-.6M18.514 78.515a.6.6 0 0 1 .6.6v4.628a4.8 4.8 0 0 0 4.8 4.8h7.136a.6.6 0 0 1 0 1.2h-7.136a6 6 0 0 1-6-6v-4.628a.6.6 0 0 1 .6-.6m82.286 0a.6.6 0 0 1 .6.6v4.628a6 6 0 0 1-6 6H87.62a.6.6 0 1 1 0-1.2H95.4a4.8 4.8 0 0 0 4.8-4.8v-4.628a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5981E3",
    d: "M49.372 51.772a9.257 9.257 0 1 1-18.515 0 9.257 9.257 0 0 1 18.515 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9ED",
    d: "M54.172 58.286a2.743 2.743 0 0 1 2.742-2.743h30.172a2.743 2.743 0 1 1 0 5.486H56.914a2.743 2.743 0 0 1-2.742-2.743M32.914 74.743A2.743 2.743 0 0 1 35.657 72h8.229a2.743 2.743 0 0 1 0 5.486h-8.229a2.743 2.743 0 0 1-2.743-2.743M76.8 74.743A2.743 2.743 0 0 1 79.543 72h8.914a2.743 2.743 0 0 1 0 5.486h-8.914a2.743 2.743 0 0 1-2.743-2.743"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#89A8F8",
    d: "M54.172 48.686a2.743 2.743 0 0 1 2.742-2.743h17.143a2.743 2.743 0 0 1 0 5.486H56.914a2.743 2.743 0 0 1-2.742-2.743"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.837 50.351a3.722 3.722 0 1 1-7.445 0 3.722 3.722 0 0 1 7.445 0m-.931 0a2.792 2.792 0 1 1-5.584 0 2.792 2.792 0 0 1 5.584 0",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.114 55.004c-2.052 0-3.531.483-4.578 1.254-1.049.771-1.62 1.797-1.917 2.802a.465.465 0 0 0 .893.264c.253-.857.726-1.692 1.575-2.316.85-.626 2.12-1.073 4.027-1.073s3.178.447 4.028 1.072c.848.625 1.322 1.46 1.575 2.317a.465.465 0 1 0 .892-.264c-.296-1.005-.868-2.03-1.916-2.802-1.047-.77-2.526-1.254-4.579-1.254"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "DocumentPersonal_svg__a",
    width: 89.943,
    height: 65.943,
    x: 14.686,
    y: 35.029,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "effect1_dropShadow_9126_2814"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9126_2814"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9126_2814",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentPersonal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "14d6d653314fe9a5bb7a44bb4b46d7a3.svg";